import { render, staticRenderFns } from "./termsofuse.vue?vue&type=template&id=b321e86a&scoped=true"
import script from "./termsofuse.vue?vue&type=script&lang=js"
export * from "./termsofuse.vue?vue&type=script&lang=js"
import style0 from "./termsofuse.vue?vue&type=style&index=0&id=b321e86a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b321e86a",
  null
  
)

export default component.exports